import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';
import { ReceiverDetails, ReceiverWebsite } from '../../../types/receiver';

export type CompanyProfileState = {
  companyInfo?: ReceiverDetails;
  websites: ReceiverWebsite[];
  fetchingCompanyInfo: boolean;
};

const initialState = {
  companyInfo: undefined,
  websites: [],
  fetchingCompanyInfo: false,
};

const reducer: Reducer<CompanyProfileState, FluxStandardAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FETCH_COMPANY_PROFILE_PENDING':
      return {
        ...state,
        fetchingCompanyInfo: true,
      };
    case 'FETCH_COMPANY_PROFILE_FULFILLED': {
      const companyInfo = action.payload.data;

      companyInfo.websites = state.websites;

      return {
        ...state,
        fetchingCompanyInfo: false,
        companyInfo,
      };
    }
    case 'FETCH_RECEIVER_TRAFFIC_DATA_FULFILLED': {
      if (state.companyInfo && action.meta.receiverId === state.companyInfo.id) {
        const { data: websites } = action.payload.data;

        return {
          ...state,
          companyInfo: {
            ...state.companyInfo,
            websites: websites.map((w: any) => ({
              id: w.id,
              url: w.url,
              isPrimary: w.is_primary,
              trafficData: w.traffic_data,
            })),
          },
        };
      }
      return state;
    }
  }
  return state;
};

export default reducer;
